module.exports = __webpack_public_path__ + "img/proudly-supporting.10b15701.png";